import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "RulerAlt"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.057 16.2525L7.75455 1.93505C7.4732 1.65338 7.09141 1.49512 6.6933 1.49512C6.29518 1.49512 5.9134 1.65338 5.63205 1.93505L1.94205 5.63255C1.36046 6.2176 1.36046 7.16249 1.94205 7.74755L16.2445 22.065C16.5276 22.3458 16.9108 22.5024 17.3095 22.5C17.7057 22.5004 18.0858 22.344 18.367 22.065L22.057 18.3675C22.6386 17.7825 22.6386 16.8376 22.057 16.2525ZM17.3096 21L2.99964 6.69004L6.68964 3.00004L9.53214 5.84254L7.84464 7.50004L8.90214 8.55754L10.5896 6.90004L13.6871 9.99754L11.9996 11.685L13.0646 12.75L14.7521 11.0625L17.8496 14.16L16.1621 15.8475L17.2496 16.905L18.9371 15.2175L20.9996 17.31L17.3096 21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/RulerAlt.vue"]]);
